import { getQueryParams } from './query_string_helpers';
import { getTruthy } from './dom_helpers';

function isFrameWindow(): boolean {
  try {
    return window.self !== window.top;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return true;
  }
}

export function isEmbedFrame(): boolean {
  if (!isFrameWindow()) {
    return false;
  }

  const { embedded } = getQueryParams();
  return getTruthy(embedded);
}

export function callParentIFrame(callback: () => void): void {
  const isFrameMessengerReady = 'parentIFrame' in window;
  if (isFrameMessengerReady) {
    callback();
  } else {
    window.addEventListener('parentIFrameReady', () => callback());
  }
}
